var BaseViews = require('../base');
var algoliasearch = require('algoliasearch/lite');
var autocomplete = require('autocomplete.js');
var ProductVendorEntities = require('../../admin-app/entities/product-vendor');
require('./algolia-vendor-search/algolia-vendor-search.scss');
var Spinner = require('treeline-shared-components/spinner');

var AlgoliaVendorSearch = BaseViews.LayoutView.extend({
    className: 'algolia-vendor-search-container',
    
    initialize: function(options) {
        this.options = options || {};
        this.options.useLegacySearch = !(this.options.vendorSearchEnabled === true);
        
        if (!this.options.useLegacySearch) {
            this.searchClient = algoliasearch(
                this.options.algoliaAppId,
                this.options.algoliaSearchApiKey
            );

            this.filterLocation = this.options._appChannel ? 
                this.options._appChannel.request('get:filter:location') : 
                'downtownvictoria';
            
            if (this.options._appChannel) {
                this.listenTo(this.options._appChannel, 'search:options:changed', this.handleLocationChange);
            }
            
            this._currentPage = 0;
            this._isLoading = false;
            this._hasMoreResults = true;
            this._currentQuery = '';
            this._currentHits = [];
            this._isInitialLoad = true;
            this.options.disableAnalytics = !!this.options.disableAnalytics;
        }
    },
    
    regions: {
        loaderRegion: '.tl-loader-region',
        legacySearchRegion: '.legacy-search-region'
    },

    template: function() {
        this.options = this.options || {};
        
        if (this.options.useLegacySearch) {
            return `
                <div class="legacy-search-region" style="width: 100%;"></div>
            `;
        } else {
            return `
                <div class="algolia-vendor-search-wrapper">
                    <div class="aa-input-wrapper">
                        <svg class="aa-search-icon" viewBox="0 0 24 24" width="24" height="24">
                            <path fill="currentColor" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                        </svg>
                        <input type="search" placeholder="Search vendors..." class="aa-input">
                        <svg class="aa-clear-icon" viewBox="0 0 24 24" width="24" height="24">
                            <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </div>
                    <div class="tl-loader-region"></div>
                    <div class="vendors-container"></div>
                </div>
            `;
        }
    },
    
    events: {
        'click .aa-clear-icon': 'clearSearch'
    },
    
    clearSearch: function() {
        const input = this.el.querySelector('input');
        if (input) {
            input.value = '';
            input.focus();
            this.toggleClearButton();
            
            if (this.el) {
                const container = this.el.querySelector('.vendors-container');
                if (container) {
                    container.innerHTML = '<div class="loading-placeholder">Loading vendors...</div>';
                }
            }
            
            this._loadInitialVendors();
        }
    },
    
    toggleClearButton: function() {
        const input = this.el.querySelector('input');
        const clearButton = this.el.querySelector('.aa-clear-icon');
        if (input && clearButton) {
            clearButton.style.display = input.value ? 'block' : 'none';
        }
    },
    
    onRender: function() {
        if (!this.el) {
            console.error('AlgoliaVendorSearch: Element does not exist on render');
            if (this.options._appChannel) {
                this.options._appChannel.trigger('use:legacy:vendor:search');
            }
            return;
        }
        
        if (this.options.useLegacySearch) {
            this._renderLegacySearch();
        } else {
            this.initAutocomplete();
        }
    },
    
    _renderLegacySearch: function() {
        var self = this;
        var DropdownListInner = require('treeline-shared-components/dropdown-list/dropdown-list-inner.js');
        
        this.options = this.options || {};
        if (!this.options._appChannel) {
            console.error('AlgoliaVendorSearch: _appChannel is required for vendor search');
            return;
        }
        
        if (!this.legacySearchRegion || !this.legacySearchRegion.$el || !this.legacySearchRegion.$el.length) {
            console.error('AlgoliaVendorSearch: legacySearchRegion does not exist');
            if (this.options._appChannel) {
                this.options._appChannel.trigger('use:legacy:vendor:search');
            }
            return;
        }
        
        var vendorCollection = new ProductVendorEntities.PageableProductVendorsCollection(
            self.options._appChannel.request('get:vendors').toJSON(), 
            {
                queryParams: {
                    filterHideOnMenuFilter: true,
                    filterOutOfStock: true
                }
            }
        );

        self.vendorDropdownList = new DropdownListInner({
            collection: vendorCollection,
            dropdownCssClass: 'fmcy-menu-search-dropdown',
            suppressSearch: false,
            width: '100%',
            openAndFocused: true,
            inputFocused: false,
            displayAttr: 'name',
            iconURLAttr: 'image_thumb_url_light_theme',
            valueAttr: 'id',
            allowClear: true,
            placeholder: 'Select Brand',
            onSelectedCallback: function(vendorId, model) {
                self.options._appChannel.trigger(
                    'search:options:changed',
                    {
                        categorySlug: 'all',
                        subCategorySlug: 'all',
                        filterVendor: vendorId
                    }
                );
                self.options._appChannel.trigger('menu:search:view:close');
            }
        });
        
        this.legacySearchRegion.show(self.vendorDropdownList);
    },
    
    initAutocomplete: function() {
        const input = this.el.querySelector('input');
        if (!input) return;
        var self = this;
        
        this.options = this.options || {};
        if (!this.options.indexName || !this.options.algoliaAppId || !this.options.algoliaSearchApiKey) {
            console.error('AlgoliaVendorSearch: Missing required Algolia configuration');
            return;
        }

        this.toggleClearButton();
        
        this._loadInitialVendors();
        
        input.addEventListener('input', _.debounce(function(e) {
            const query = e.target.value;
            self.toggleClearButton();
            
            const container = self.el.querySelector('.vendors-container');
            if (container && query !== self._currentQuery) {
                if (query.length > 0) {
                    container.innerHTML = '<div class="loading-placeholder">Searching...</div>';
                }
            }
            
            if (query.length === 0) {
                // If search is cleared, show all vendors again
                self._loadInitialVendors();
            } else {
                self._searchVendors(query);
            }
        }, 300));
        
        input.addEventListener('keydown', function(e) {
            self._handleKeydown(e);
        });
        
        const vendorsContainer = this.el.querySelector('.vendors-container');
        if (vendorsContainer) {
            vendorsContainer.addEventListener('scroll', _.throttle(function() {
                self._handleScroll();
            }, 200));
        }
        
        setTimeout(function() {
            input.focus();
        }, 0);
    },
    
    _loadInitialVendors: function() {
        var self = this;
        this._currentPage = 0;
        this._currentQuery = '';
        this._isInitialLoad = true;
        this._isLoading = true;
        this._initialLoadAttempts = 0; // Track initial load attempts
        
        if (this.el) {
            const container = this.el.querySelector('.vendors-container');
            if (container) {
                container.innerHTML = '<div class="loading-placeholder">Loading vendors...</div>';
            }
        }
        
        this.filterLocation = this.options._appChannel ? 
            this.options._appChannel.request('get:filter:location') : 
            this.filterLocation || 'downtownvictoria';
        
        this._searchVendors('');
    },
    
    _searchVendors: function(query) {
        var self = this;
        
        // Reset pagination and clear results when query changes
        const isNewQuery = query !== this._currentQuery;
        if (isNewQuery) {
            this._currentPage = 0;
            this._initialLoadAttempts = 0; // Reset load attempts for new queries
            // Clear existing results immediately for a new search
            if (this.el) {
                const container = this.el.querySelector('.vendors-container');
                if (container) {
                    container.innerHTML = '';
                }
            }
        }
        
        this._currentQuery = query;
        // Get current location for filtering
        const filterLocation = this.filterLocation || 'downtownvictoria';
        // Create location-based filter
        const filterString = `in_stock_${filterLocation}:true`;
        
        // Use the same approach for both empty and non-empty queries
        // for consistency and to ensure pagination works in all cases
        this._isLoading = true;
        
        this.searchClient.initIndex(this.options.indexName)
            .search(query, {
                hitsPerPage: 100,  // Get more vendors to ensure we have a good sample
                page: this._currentPage,
                analytics: this.options.disableAnalytics ? false : undefined,
                facets: ['vendor_name', `in_stock_${filterLocation}`],
                filters: filterString,
                attributesToRetrieve: [
                    'vendor_name', 
                    'vendor', 
                    'objectID',
                    `in_stock_${filterLocation}`,
                    'image_thumb_url_dark_theme',
                    'image_thumb_url',
                    'image_thumb_url_light_theme'
                ],
                attributesToHighlight: ['vendor_name'],
                highlightPreTag: '<strong>',
                highlightPostTag: '</strong>',
                distinct: 1
            })
            .then(function(content) {
                self._hasMoreResults = self._currentPage < content.nbPages - 1;
                
                // Process results to get unique vendors only
                const vendors = {};
                
                // First pass: collect all vendors with proper product matches
                content.hits.forEach(function(hit) {
                    if (hit.vendor && hit.vendor.id && (!filterLocation || hit[`in_stock_${filterLocation}`] === true)) {
                        // Keep highlighted version of vendor name if available
                        if (hit._highlightResult && hit._highlightResult.vendor_name) {
                            if (!vendors[hit.vendor.id] || 
                                hit._highlightResult.vendor_name.matchLevel === 'full') {
                                // If this is a new vendor or it's a better match, update
                                const vendor = hit.vendor;
                                vendor.highlighted_name = hit._highlightResult.vendor_name.value;
                                vendor.matchLevel = hit._highlightResult.vendor_name.matchLevel;
                                vendor.matchedQuery = query;
                                // Ensure we have the correct image URL
                                vendor.image_thumb_url_dark_theme = hit.vendor.image_thumb_url_dark_theme || hit.vendor.image_thumb_url_dark_theme;
                                vendor.image_thumb_url = hit.vendor.image_thumb_url || hit.vendor.image_thumb_url;
                                vendor.image_thumb_url_light_theme = hit.vendor.image_thumb_url_light_theme || hit.vendor.image_thumb_url_light_theme;
                                vendors[hit.vendor.id] = vendor;
                            }
                        } else if (!vendors[hit.vendor.id]) {
                            // Only add if we don't already have this vendor
                            vendors[hit.vendor.id] = hit.vendor;
                        }
                    }
                });
                
                // Convert to array for processing
                const vendorResults = Object.values(vendors);
                
                // Sort vendors: better matches first, then by priority
                vendorResults.sort(function(a, b) {
                    // For text searches, put exact matches first
                    if (query && a.matchLevel !== b.matchLevel) {
                        if (a.matchLevel === 'full') return -1;
                        if (b.matchLevel === 'full') return 1;
                    }
                    
                    // Otherwise sort by priority
                    const priorityA = a.algolia_search_priority || 0;
                    const priorityB = b.algolia_search_priority || 0;
                    return priorityB - priorityA;
                });
                
                if (isNewQuery || self._currentPage === 0) {
                    self._currentHits = vendorResults;
                    self._renderVendors(vendorResults);
                    self._isInitialLoad = false;
                } else {
                    // For pagination, we need to deduplicate with existing results
                    const existingIds = self._currentHits.map(vendor => vendor.id);
                    const newVendors = vendorResults.filter(vendor => !existingIds.includes(vendor.id));
                    
                    self._currentHits = [...self._currentHits, ...newVendors];
                    self._appendVendors(newVendors);
                }
                
                // Hide loader after results are received
                if (self._loader) {
                    self.loaderRegion.empty();
                    self._loader = null;
                }
                self._isLoading = false;
                
                // For initial loads, check if we should auto-load more results
                if (self._initialLoadAttempts < 3) {
                    self._checkAndLoadMoreIfNeeded(true);
                }
            })
            .catch(function(error) {
                console.error('Error searching vendors:', error);
                if (self._loader) {
                    self.loaderRegion.empty();
                    self._loader = null;
                }
                self._isLoading = false;
                
                // Show error message
                const container = self.el.querySelector('.vendors-container');
                if (container) {
                    container.innerHTML = '<div class="no-results">Error loading vendors.</div>';
                }
            });
    },
    
    _renderVendors: function(vendors) {
        const container = this.el.querySelector('.vendors-container');
        if (!container) return;
        
        container.innerHTML = '';
        
        if (vendors.length === 0) {
            container.innerHTML = '<div class="no-results">No vendors found</div>';
            return;
        }
        
        const vendorsWrapper = document.createElement('div');
        vendorsWrapper.className = 'aa-dropdown-menu-visible';
        
        vendors.forEach(vendor => {
            const vendorElement = document.createElement('div');
            vendorElement.className = 'aa-suggestion vendor-item';
            vendorElement.innerHTML = this.renderVendorItem(vendor);
            vendorElement.addEventListener('click', () => {
                this._handleVendorSelection(vendor);
            });
            vendorsWrapper.appendChild(vendorElement);
        });
        
        container.appendChild(vendorsWrapper);
        
        // Check if we need to auto-load more results
        this._checkAndLoadMoreIfNeeded();
    },
    
    _appendVendors: function(vendors) {
        const container = this.el.querySelector('.vendors-container');
        if (!container) return;
        
        const vendorsWrapper = container.querySelector('.aa-dropdown-menu-visible');
        if (!vendorsWrapper) return;
        
        const newVendorsContainer = document.createElement('div');
        newVendorsContainer.className = 'aa-infinite-scroll-results';

        vendors.forEach(vendor => {
            const vendorElement = document.createElement('div');
            vendorElement.className = 'aa-suggestion vendor-item';
            vendorElement.innerHTML = this.renderVendorItem(vendor);
            vendorElement.addEventListener('click', () => {
                this._handleVendorSelection(vendor);
            });
            newVendorsContainer.appendChild(vendorElement);
        });
        
        vendorsWrapper.appendChild(newVendorsContainer);
        
        // Check if we need to auto-load more results
        this._checkAndLoadMoreIfNeeded();
    },
    
    _checkAndLoadMoreIfNeeded: function(isInitialCheck = false) {
        // If we're already loading, don't trigger another load
        if (this._isLoading || !this._hasMoreResults) return;
        
        const container = this.el.querySelector('.vendors-container');
        if (!container) return;
        
        // Check if we need to load more pages
        let shouldLoadMore = false;
        
        if (isInitialCheck) {
            // For initial loads, we want to be more aggressive
            this._initialLoadAttempts++; 
            
            // Check if we have fewer vendors than would fill the container
            const vendorItems = container.querySelectorAll('.vendor-item');
            const containerHeight = container.clientHeight;
            
            // Use a more aggressive minimum - either calculated or fixed minimum
            const calculatedMinVendors = Math.floor(containerHeight / 50); // Use 50px per vendor (smaller than actual)
            const minDesiredVendors = Math.max(calculatedMinVendors, 50); // Set a minimum of 50 vendors
            
            // For initial loads, always load at least 2 pages to ensure adequate content
            shouldLoadMore = vendorItems.length < minDesiredVendors || this._initialLoadAttempts < 3;
        } else {
            // For regular checks, use scrollability
            shouldLoadMore = container.scrollHeight <= container.clientHeight;
        }
        
        // If we need more content, load more
        if (shouldLoadMore && this._hasMoreResults) {
            setTimeout(() => {
                this._loadMoreVendors();
            }, 100);
            return true;
        }
        
        return false;
    },
    
    _handleVendorSelection: function(vendor) {
        if (this.options._appChannel) {
            this.options._appChannel.trigger(
                'search:options:changed',
                {
                    categorySlug: 'all',
                    subCategorySlug: 'all',
                    filterVendor: vendor.id
                }
            );
            this.options._appChannel.trigger('menu:search:view:close');
        }
    },
    
    _handleKeydown: function(e) {
        if (!this.el) return;
        
        const container = this.el.querySelector('.vendors-container');
        if (!container) return;
        
        const vendorItems = container.querySelectorAll('.vendor-item');
        if (!vendorItems.length) return;
        
        let currentIndex = Array.from(vendorItems).findIndex(item => item.classList.contains('highlighted'));
        
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                currentIndex = currentIndex < vendorItems.length - 1 ? currentIndex + 1 : 0;
                this._highlightVendorItem(vendorItems, currentIndex);
                if (vendorItems[currentIndex]) {
                    this._scrollIntoViewIfNeeded(vendorItems[currentIndex], container);
                }
                break;
                
            case 'ArrowUp':
                e.preventDefault();
                currentIndex = currentIndex > 0 ? currentIndex - 1 : vendorItems.length - 1;
                this._highlightVendorItem(vendorItems, currentIndex);
                if (vendorItems[currentIndex]) {
                    this._scrollIntoViewIfNeeded(vendorItems[currentIndex], container);
                }
                break;
                
            case 'Enter':
                e.preventDefault();
                if (currentIndex >= 0 && vendorItems[currentIndex]) {
                    vendorItems[currentIndex].click();
                }
                break;
        }
    },
    
    _highlightVendorItem: function(items, index) {
        items.forEach(item => {
            item.classList.remove('highlighted');
        });

        if (index >= 0 && index < items.length) {
            items[index].classList.add('highlighted');
        }
    },
    
    _scrollIntoViewIfNeeded: function(element, container) {
        if (!element || !container) return;
        
        try {
            const containerRect = container.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();
    
            if (elementRect.bottom > containerRect.bottom) {
                element.scrollIntoView(false);
            } else if (elementRect.top < containerRect.top) {
                element.scrollIntoView(true);
            }
        } catch (e) {
            console.error('Error in _scrollIntoViewIfNeeded:', e);
        }
    },
    
    _handleScroll: function() {
        if (!this.el || this._isLoading) return;
        
        const vendorsContainer = this.el.querySelector('.vendors-container');
        if (!vendorsContainer) return;
        
        // Check if scrolled close to bottom
        if (vendorsContainer.scrollTop + vendorsContainer.clientHeight >= vendorsContainer.scrollHeight - 100) {
            // Make sure we have more results to load before triggering pagination
            if (this._hasMoreResults) {
                this._loadMoreVendors();
            }
        }
    },
    
    _loadMoreVendors: function() {
        this._currentPage++;
        this._searchVendors(this._currentQuery);
    },
    
    renderVendorItem: function(vendor) {
        const thumbnailUrl = vendor.image_thumb_url_dark_theme || vendor.image_thumb_url_light_theme || '';
        
        const vendorName = vendor.highlighted_name || vendor.name;
        
        return [
            '<div class="aa-ItemWrapper">',
                '<div class="aa-ItemContent">',
                    thumbnailUrl ? [
                        '<div class="aa-ItemIcon aa-ItemIcon--alignTop">',
                            '<img ',
                                'src="' + thumbnailUrl + '" ',
                                'alt="' + vendor.name + '"',
                            '/>',
                        '</div>'
                    ].join('') : '',
                    '<div class="aa-ItemContentBody">',
                        '<div class="aa-ItemContentTitle">',
                            vendorName,
                        '</div>',
                    '</div>',
                '</div>',
            '</div>'
        ].join('');
    },
    
    handleLocationChange: function(options) {
        if (options.location && options.location !== this.filterLocation) {
            this.filterLocation = options.location;
            if (this.el) {
                const input = this.el.querySelector('input');
                if (input) {
                    const query = input.value || '';
                    const container = this.el.querySelector('.vendors-container');
                    if (container) {
                        container.innerHTML = '<div class="loading-placeholder">Updating location...</div>';
                    }
                    // Re-search with current query and new location
                    this._searchVendors(query);
                }
            }
        }
    }
});

module.exports = AlgoliaVendorSearch; 


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/search/algolia-vendor-search.js
 ** module id = 691
 ** module chunks = 1 64 99
 **/